

import { extractCdnPathFromOneValueOfSmetioFileInput } from "@schaniag/private";
import { SmetioCustomerWebsiteSection } from "../../smetioCustomerWebsiteSection.js/v1.0.0/SmetioCustomerWebsiteSection.js";



export class SmetioCustomerWebsiteTreatments extends SmetioCustomerWebsiteSection {

    constructor(data = {}) {


        super(data);

        this.sectionId = "smetio-template-services";
        this.treatmentsArray = [];
        this.treatments = {};
        this.table = "treatments";
        this.appUserInterface = "business";
        this.nextSectionClass = null;
        this.smetioSmartBox;

        this.hairLengthTxt = {
            short: "txt1206",
            medium: "txt1207",
            long: "txt1208",
            extraLong: "txt1209"
        };

        this.beardLengthTxt = {
            short: "txt1229",
            medium: "txt1230",
            long: "txt1231",
            extraLong: "txt1232"
        };

        this.mainClass = "smetio-customer-website-treatments-" + this.id;
        this.mainAttributes = {
            id: this.sectionId,
            class: ["smetio-customer-website-treatments", this.mainClass],
        };

        this.treatmentsItemsClass = "smetio-customer-website-treatments-items-" + this.id;
        this.treatmentsItemsAttributes = {
            class: ["smetio-customer-website-treatments-items", this.treatmentsItemsClass],
        };


    };

    getHighestAndLowest(data = {}) {

        const { valuesObject } = data;

        let highest = 0;
        let lowest = 0;

        for (const key in valuesObject) {

            const value = parseInt(valuesObject[key]);

            if (value > highest) highest = value;

            if (value < lowest) lowest = value;

            if (lowest === 0) lowest = value;

        };

        return { highest, lowest };
    };
    
    getTreatmentDetailsFromArray(data ={}) {
        const { index } = data;

        const treatmentDetails = this.treatmentsArray[index];

        console.log("treatmentDetails is ", treatmentDetails);

        let {
            prices, whatBodyPart, discountsAndPoints, averagePerformanceMarginOfError, generalComments,
            cancellationPolicy, description, customDescription, processedData, customizationOptions,
            averageTimeOfPerformanceInMinutes, customName,
            frontView, backView, leftView, rightView, video1, video2

        } = treatmentDetails;
        const { bodyPartForDataPresentation, treatmentName, highestAndLowestPrices, coverImage, token } = processedData || {};

        frontView = this.handlePhotoAndVideo({ photoOrVideoName: "frontView", photoOrVideoObj: frontView, customizationOptions });
        backView = this.handlePhotoAndVideo({ photoOrVideoName: "backView", photoOrVideoObj: backView, customizationOptions });
        leftView = this.handlePhotoAndVideo({ photoOrVideoName: "leftView", photoOrVideoObj: leftView, customizationOptions });
        rightView = this.handlePhotoAndVideo({ photoOrVideoName: "rightView", photoOrVideoObj: rightView, customizationOptions });
        video1 = this.handlePhotoAndVideo({ photoOrVideoName: "video1", photoOrVideoObj: video1, customizationOptions });
        video2 = this.handlePhotoAndVideo({ photoOrVideoName: "video2", photoOrVideoObj: video2, customizationOptions });        

        // const {longestTime, shortestTime} = this.getShortestAndLongestTimeOfPerformance({times:averageTimeOfPerformanceInMinutes});
        const timeRange = this.getHighestAndLowest({ valuesObject: averageTimeOfPerformanceInMinutes });
        const discountRange = this.getHighestAndLowest({ valuesObject: discountsAndPoints });   

        description = typeof description === "object" ? description[this.language] ?? Object.values(description)[0] : description;

        customDescription = typeof customDescription === "object" ? customDescription[this.language] ?? Object.values(customDescription)[0] : "";
        description = !this.isEmpty(customDescription) ? customDescription : description;

        generalComments = typeof generalComments === "object" ? generalComments[this.language] ?? Object.values(generalComments)[0] : "";
        
        return {
            processedData, customizationOptions, averageTimeOfPerformanceInMinutes, customName, discountsAndPoints,
            bodyPartForDataPresentation, treatmentName, highestAndLowestPrices, coverImage, token,
            timeRange, discountRange, description, cancellationPolicy, generalComments, prices, whatBodyPart,averagePerformanceMarginOfError,
            frontView, backView, leftView, rightView, video1, video2
        }

    };

    async getBookAppointmentFunc() {

        if (this.bookAppointmentFunc) return false;
        const { bookAppointment } = (await import(/* webpackPrefetch: true */ "../../../functions/apps/bookings/bookAppointment.js"));

        this.bookAppointmentFunc = bookAppointment;
    }

    async displayTreatments() {

        // const extractCdnPathFromOneValueOfSmetioFileInput = (await import(/* webpackPrefetch: true */ "@schaniag/private")).extractCdnPathFromOneValueOfSmetioFileInput;
        const { SmetioPhotoAndDescription } = (await import(/* webpackPrefetch: true */ "../../smetioPhotoAndDescription/v1.0.0/smetioPhotoAndDescription.js"));

        const bookText = this.setTxt({
            attributes: {},
            txt: "txt1356",
            type: "html"
        });

        const priceTitle = this.setTxt({
            attributes: {},
            txt: "txt1337",
            type: "title"
        });

        const timeTitle = this.setTxt({
            attributes: {},
            txt: "txt1302",
            type: "title"
        });

        const discountTitle = this.setTxt({
            attributes: {},
            txt: "txt1338",
            type: "title"
        });

        const minutesText = this.setTxt({
            attributes: {},
            txt: "txt1478",
            type: "html"
        });

        const unavailableText = this.setTxt({
            attributes: {},
            txt: "txt1479",
            type: "html"
        });

        let settings = {
            orientation: "vertical",
            boxWidth: "20%",
            boxMinWidth: "250px",
            // boxMaxWidth: this.totalNumberOfData > 4 ? "250px" : "400px",
            boxMaxWidth: "250px",
            boxMinHeight: "600px",
            boxMaxHeight: "1500px",

                
            photoMaxHeight: "1000px",
            // photoMinHeight: "300px",

            boxMargin: "10px",
            boxPadding: "10px",
            photoWidth: "100%",
            photoVPosition: "center",
            descriptionVPosition: "top",
        };

        // if(this.totalNumberOfData == 1) settings = this.getSettingsForOneTeamMember();
        await this.getBookAppointmentFunc();

        for (let i = 0; i < this.treatmentsArray.length; i++) {

            let {
                processedData, customizationOptions, averageTimeOfPerformanceInMinutes, customName, discountsAndPoints,
                bodyPartForDataPresentation, treatmentName, highestAndLowestPrices, coverImage, token,
                timeRange, discountRange, frontView = {}, backView = {}, leftView ={}, rightView ={}, video1 = {}, video2={}
            } = this.getTreatmentDetailsFromArray({ index: i });

            window.linkFunc = (event) => {
                return this.bookAppointmentFunc({ event, treatmentDetails:this.treatmentsArray[i] });
            };

            let { bookingLink } = customizationOptions;
            // frontView = Object.keys(frontView).length > 1 ? frontView : customizationOptions.frontView;
            const { highestPrice, lowestPrice } = highestAndLowestPrices;
            const businessBookingLink = this.usefulLinksObj["plainObj"]["bookAppointment"]["href"];
            const bookAppointmentLink = !this.isEmpty(bookingLink) ? bookingLink : businessBookingLink;

            const onClick = !this.isEmpty(bookingLink) ? "" : `onclick="event.stopPropagation(); window.linkFunc(event);"`;
            // onclick="event.stopPropagation(); myFunc()"

            const name = customName ? customName : treatmentName;
            const bodyPartInfo = bodyPartForDataPresentation.replace(/\s+/g, " ").trim();

            let timeOfPerformance = timeRange.lowest === 0 && timeRange.highest === 0 ? unavailableText : `${timeRange.lowest} - ${timeRange.highest} ${minutesText.toLowerCase()}`;
            timeOfPerformance = timeOfPerformance === unavailableText ? "" : `<div title="${timeTitle}" class="smetio-customer-website-treatment-description-text-with-icon"><i class="smetio-icon smetio-icon-alarm"></i> ${timeOfPerformance} </div>`;
            
            let discountsPercentage = discountRange.lowest === 0 && discountRange.highest === 0 ? unavailableText : `${discountRange.lowest}% - ${discountRange.highest}%`;
            discountsPercentage = discountsPercentage === unavailableText ? "" : `<div title="${discountTitle}" class="smetio-customer-website-treatment-description-text-with-icon"><i class="smetio-icon smetio-icon-gift2"></i> ${discountsPercentage} </div>`


            const description = `
                <div class="smetio-customer-website-treatment-description"  >

                    <div class="smetio-customer-website-treatment-description-text" >
                            <h4>${name}</h4>
                            <p class="smetio-customer-website-treatment-description-text-body-part">${bodyPartInfo} </p>
                            <div title="${priceTitle}" class="smetio-customer-website-treatment-description-text-with-icon"><i class="smetio-icon smetio-icon-credit-card1"></i><strong>${lowestPrice} - ${highestPrice}</strong></div>
                            ${timeOfPerformance}
                            ${discountsPercentage}
                    </div>      

                    <button onclick="event.stopPropagation();" class="smetio-customer-website-description-book-with-me" >
                            <a ${onClick} href="${bookAppointmentLink}" target="_self">${bookText}</a>
                    </button>  

                </div>
            `;

            const smetioPhotoAndDescription = new SmetioPhotoAndDescription({
                photo: this.getMultimediaSrc({mediaObj:frontView, coverImage}),
                description,
                // isSelected: option.attributes.selected,
                ...settings,
                onClicked: (data = {}) => {
                    return this.showTreatmentDetails({ index: i });
                },
                // onMouseEnter: (data = {}) => {
                //   console.log("You clicked token ", token);
                //   this.zoomMapIn({token});
                // },
                // onMouseLeave:(data = {}) => {
                //   console.log("You clicked token ", token);
                //   this.zoomMapOut();
                // },
            });

            const treatment = smetioPhotoAndDescription.render();

            if (i < 1) $(`.${this.treatmentsItemsClass}`).html("");

            $(`.${this.treatmentsItemsClass}`).append(treatment);

            this.treatments[token] = i;

            // if(i > 0) break;
            // break;

        };

    };

    // async showOnSmartBox(data = {}) {
      
    //     const { content, title, position = "fixed" } = data;

    //     if (this.smetioSmartBox && this.smetioSmartBox.status !== "close") {
    //         this.smetioSmartBox.reactivate({ newHeight: "100vh", newWidth: "350px" });
    //         this.smetioSmartBox.updateTitle(title);
    //         this.smetioSmartBox.updateContent(content);
    //         this.smetioSmartBox.lock();
    //         return true;
    //     };       
        
    //     const { SmetioSmartbox }= (await import(/* webpackPrefetch: true */ "../../smetioSmartbox/v1.0.0/SmetioSmartbox.js"));

    //     this.smetioSmartBox = new SmetioSmartbox();

    //     this.smetioSmartBox.position = position;
    //     this.smetioSmartBox.title = title;
    //     this.smetioSmartBox.content = content;
    //     this.smetioSmartBox.onClose = () => { this.smetioSmartBox = null; };
    //     this.smetioSmartBox.render();  
    //     this.smetioSmartBox.lock();

    // };
    
    getMultimediaSrc(data = {}) {
        let { mediaObj, coverImage } = data;

        mediaObj = typeof mediaObj === "object" ? mediaObj  : {};
        const image = Object.keys(mediaObj).length > 0 ? mediaObj : Object.values(coverImage);
        
        let src = extractCdnPathFromOneValueOfSmetioFileInput(image);
    
        return src ? src.replace("landscape", "portrait") : `${window.cdnPath}/img/placeholders/placeholderProfileImage.PNG`;   
        
    };

    getCancellationPolicyDisplay(data = {}) { 

        const { cancellationPolicy } = data;
        const { permittedReschedule = 0 } = cancellationPolicy;

        const para1 = this.setTxt({
            attributes: {},
            txt: "txt1868",
            type: "html"
        });             

        const para2 = this.setTxt({
            attributes: {},
            txt: "txt1869",
            type: "html"
        });           
        
        const para3 = this.setTxt({
            attributes: {},
            txt: "txt1870",
            type: "html"
        });   
        
        let rescheduleTxt = this.setTxt({
            attributes: {},
            txt: "txt1871",
            type: "html"
        });   
        
        rescheduleTxt = rescheduleTxt.replace("123%456", permittedReschedule).replace("456%122", "24"); 
            
        
        let lis = "";
        const policyAndTxt = {
            abusiveCancellation: "txt1285",
            disruptiveCancellation: "txt1287",
            normalCancellation:"txt1289"
        };

        for (const key in cancellationPolicy) {
            
            if (key === "permittedReschedule") continue;

            const percentage = cancellationPolicy[key];
            const text = this.setTxt({
                attributes: {},
                txt: policyAndTxt[key],
                type: "html"
            });   
                
            lis +=`<li>${text}: <strong>${percentage}%</strong></li>`
        }
     
        const output = `
            <div class="smetio-customer-website-treatment-details-display-drop-down-details-item">

                <p>${para1}</p>

                <p>${para2}</p>

                <p class="smetio-dominant-text"> <i>${para3} </i> </p>

                <ul>${lis}</ul>

                <p>${rescheduleTxt}</p>
               
            </div>
        `;

        return output;
    };

    getDiscountsAndPointsDisplay(data = {}) {

        const { discountsAndPoints } = data;

        const para1 = this.setTxt({
            attributes: {},
            txt: "txt1876",
            type: "html"
        });     

        const para2 = this.setTxt({
            attributes: {},
            txt: "txt1870",
            type: "html"
        });        

        const para3 = this.setTxt({
            attributes: {},
            txt: "txt1877",
            type: "html"
        });                 
        
        const discountsAndText = {
            studentDiscount: "txt1458",
            seniorDiscount: "txt1459",
            groupDiscount2To4: "txt1251",
            groupDiscount5To10: "txt1252",
            groupDiscountAbove10: "txt1253",
            offPeakHourDiscount: "txt1873",
            cashPoint: "txt1872",
            referalPoint: "txt1874",
            influencerReferalPoint: "txt1875"
        };

        let lis = "";

        for (const key in discountsAndText) {
            
            const percentage = discountsAndPoints[key];
            const text = this.setTxt({
                attributes: {},
                txt: discountsAndText[key],
                type: "html"
            });   
                
            lis +=`<li>${text}: <strong>${percentage}%</strong></li>`
        };
                     
        const output = `
            <div class="smetio-customer-website-treatment-details-display-drop-down-details-item">
                <p>${para1}</p>
                <p class="smetio-dominant-text"> <i>${para2} </i> </p>
                <ul> ${lis} </ul>
                <p>${para3}</p>
            </div>
        `;

        return output;
   
    };

    getFaqDisplay() {
        
        const faq = {
            groupDiscount: { question: "txt1244", answer: ["txt1878", "txt1879"] },
            offPeakHourDiscount: { question: "txt1239", answer: ["txt1880", "txt1881"] },
            cashPoint: { question: "txt1257", answer: ["txt1882", "txt1883"] },
            referralPoint: { question: "txt1263", answer: ["txt1884", "txt1885", "txt1886", "txt1887", "txt1888"] },
            influencerReferral: { question: "txt1273", answer: ["txt1889", "txt1890"] },
        };

        let qNa = "";

        const collectAns = (answer) => {

            let output = "";
            for (let i = 0; i < answer.length; i++) {
                const text = this.setTxt({
                    attributes: {},
                    txt:  answer[i],
                    type: "html"
                });                 
                output += `<p class="smetio-p-text-size">${text}</p>`                
            };

            return output;
        };

        for (const key in faq) {
            
            let { question, answer } = faq[key];

            question = this.setTxt({
                attributes: {},
                txt: question,
                type: "html"
            });         
                    
            qNa += `
                <p class="smetio-p-text-size"> <strong>${question}</strong> </p>
                ${collectAns(answer)}
            `;                        
        };

        return qNa;

    };

    processPriceDisplay(data = {}) {
        const { prices, bodyPartLengthTxt, teamMemberCategories } = data;

        const { paymentCurrency } = prices;
        
        console.log("prices is ", prices,"%%%%%%%%%%%%%%%%%%");

        for (const key in prices) {

            if (key === "minimumPrice" || key === "maximumPrice") continue;

            if (key === "amountSetting" || key === "vatPercentage" || key === "paymentCurrency") continue;
            
            const keySplit = key.split("_");

            const skillLevel = keySplit[0];
            const hairLength = keySplit.pop();
            const price = prices[key];
            teamMemberCategories[skillLevel]["pricesAndLen"][hairLength] = price;   
            
        };

        let pricesBySkillLevel = "";

        for (const key in teamMemberCategories) {
           
            const {txt, pricesAndLen} = teamMemberCategories[key];
            // const { short, medium, long, extraLong } = pricesAndLen;    
            const skillLevelText = this.setTxt({ attributes: {}, txt, type: "html" }); 
            const personText = this.setTxt({ attributes: {}, txt:"txt1891", type: "html" }).toLowerCase(); 
            let lis = "";

            for (const len in pricesAndLen) {
                const lenText = this.setTxt({ attributes: {}, txt: bodyPartLengthTxt[len], type: "html" });
                const isZero = pricesAndLen[len] === 0 || pricesAndLen[len] === "0";
                const priceWithCurrency = isZero ? "N/A" : `${pricesAndLen[len]} ${paymentCurrency.toUpperCase()}`;

                lis += `<li>${lenText} : <strong>${priceWithCurrency}</strong> </li>`;                
            };
            
            pricesBySkillLevel += `   
                <div class="smetio-customer-website-treatment-details-display-drop-down-details-item">
                    <p> <strong>${skillLevelText} </strong> <span>${personText}</span> </p>
                    <ul> ${lis} </ul>
                </div>
            `;

        };

        return pricesBySkillLevel;
        
    };

    getPriceDisplayForBeard(data = {}) { 

        return this.processPriceDisplay({ ...data, bodyPartLengthTxt: this.beardLengthTxt });       
    };

    getPriceDisplayForHair(data = {}) {
        
        return this.processPriceDisplay({...data, bodyPartLengthTxt:this.hairLengthTxt})
    };

    getPriceDisplayForOtherBodyPart(data = {}) {
        const { prices, teamMemberCategories } = data;

        const { paymentCurrency } = prices;
        let lis = "";
        const personText = this.setTxt({ attributes: {}, txt:"txt1891", type: "html" }).toLowerCase(); 

        for (const key in prices) {

            if (key === "amountSetting" || key === "vatPercentage" || key === "paymentCurrency") continue;
            
            const keySplit = key.split("_");
            const skillLevel = keySplit[0];
            const price = prices[key];
            const { txt } = teamMemberCategories[skillLevel];
            const skillLevelText = this.setTxt({ attributes: {}, txt, type: "html" }); 
            const isZero = price === 0 || price === "0";
            const priceWithCurrency = isZero ? "N/A" : `${price} ${paymentCurrency.toUpperCase()}`;

            lis += `
                <li>
                    ${skillLevelText} <span>${personText}</span> : <strong>${priceWithCurrency}</strong> 
                </li>
            `;
            
        };   
        
        return `
            <div class="smetio-customer-website-treatment-details-display-drop-down-details-item">
                <ul>${lis}</ul>
            </div>
        `;

    };

    getPriceDisplay(data = {}) {
        const { whatBodyPart, prices } = data;
        const teamMemberCategories = {
            student: { txt: "txt683", pricesAndLen: {} },
            assistant: { txt: "txt687", pricesAndLen: {} },
            junior: { txt: "txt684", pricesAndLen: {} },
            senior: { txt: "txt685", pricesAndLen: {} },
            master: { txt: "txt686", pricesAndLen: {} },
        };        
        if (whatBodyPart["structure"].toLowerCase().includes("hair")) return this.getPriceDisplayForHair({ prices, teamMemberCategories });
        if (whatBodyPart["structure"].toLowerCase().includes("beard")) return this.getPriceDisplayForBeard({ prices, teamMemberCategories });

        return this.getPriceDisplayForOtherBodyPart({ prices, teamMemberCategories });

    };

    getTimeEstimateDisplay(data = {}) {
        const { whatBodyPart, averagePerformanceMarginOfError, averageTimeOfPerformanceInMinutes } = data;
        if (!averageTimeOfPerformanceInMinutes) return "N/A";

        let lengthTxt = {};
        if (whatBodyPart["structure"].toLowerCase().includes("hair")) lengthTxt = this.hairLengthTxt;
        if (whatBodyPart["structure"].toLowerCase().includes("beard")) lengthTxt = this.beardLengthTxt;

        let lis = "";
        const hoursText = this.setTxt({ attributes: {}, txt: "txt1894", type: "html" }); 
        const actualTime = this.setTxt({ attributes: {}, txt: "txt1896", type: "html" }); 
        const timeVary = this.setTxt({ attributes: {}, txt: "txt1895", type: "html" }); 

        // const timeEstimatedText = this.setTxt({ attributes: {}, txt: "txt1897", type: "html" }); 
        

        for (const key in averageTimeOfPerformanceInMinutes) {
            
            const averageTime = averageTimeOfPerformanceInMinutes[key];
            const keySplit = key.split("_");
            const len = keySplit.pop();
            const text = this.setTxt({ attributes: {}, txt: lengthTxt[len] ?? "txt1897", type: "html" }); 
            const timeIsZero = averageTime === 0 || averageTime === "0";
            const timeAndHour = timeIsZero ? "N/A" : `${averageTime} ${hoursText}`;

            lis += `<li>${text} : <strong>${timeAndHour}</strong> </li>`;  
        };

        return `
            <div class="smetio-customer-website-treatment-details-display-drop-down-details-item">
                <p> ${actualTime}  </p>
                <p class="smetio-dominant-text"> <i>${timeVary} </i> </p>
                <ul> ${lis} </ul>
            </div>        
        `;
        
    };

    handlePhotoAndVideo(data = {}) {
        let { photoOrVideoName, photoOrVideoObj = {}, customizationOptions = {} } = data;
        if (photoOrVideoObj === null) return customizationOptions[photoOrVideoName];
        return Object.keys(photoOrVideoObj).length > 0 ? photoOrVideoObj : customizationOptions[photoOrVideoName];
    };

    async showTreatmentDetails(data = {}) { 

        const { index } = data;

        let {
            processedData, customizationOptions, averageTimeOfPerformanceInMinutes, customName, discountsAndPoints,
            bodyPartForDataPresentation, treatmentName, highestAndLowestPrices, coverImage, token,
            timeRange, discountRange, description, cancellationPolicy, generalComments, whatBodyPart, prices,
            averagePerformanceMarginOfError, frontView, backView, leftView, rightView, video1, video2
        } = this.getTreatmentDetailsFromArray({ index });

        // let { frontView, backView, leftView, rightView, video1, video2, bookingLink } = customizationOptions;
        let { bookingLink } = customizationOptions;
        
        // frontView = this.handlePhotoAndVideo({ photoOrVideoName: "frontView", photoOrVideoObj: frontView, customizationOptions });
        // backView = this.handlePhotoAndVideo({ photoOrVideoName: "backView", photoOrVideoObj: backView, customizationOptions });
        // leftView = this.handlePhotoAndVideo({ photoOrVideoName: "leftView", photoOrVideoObj: leftView, customizationOptions });
        // rightView = this.handlePhotoAndVideo({ photoOrVideoName: "rightView", photoOrVideoObj: rightView, customizationOptions });
        // video1 = this.handlePhotoAndVideo({ photoOrVideoName: "video1", photoOrVideoObj: video1, customizationOptions });
        // video2 = this.handlePhotoAndVideo({ photoOrVideoName: "video2", photoOrVideoObj: video2, customizationOptions });


     
        const photoSrcs = {
            video1Src: !video1 ? false : Object.keys(video1).length > 0 ? this.getMultimediaSrc({ mediaObj: video1, coverImage }) : false,
            video2Src: !video2 ? false : Object.keys(video2).length > 0 ? this.getMultimediaSrc({ mediaObj: video2, coverImage }) : false,
            frontViewSrc: this.getMultimediaSrc({ mediaObj: frontView, coverImage }),
            backViewSrc: !backView ? false : Object.keys(backView).length > 0 ? this.getMultimediaSrc({ mediaObj: backView, coverImage }) : false,
            leftViewSrc: !leftView ? false : Object.keys(leftView).length > 0 ? this.getMultimediaSrc({ mediaObj: leftView, coverImage }) : false,
            rightViewSrc: !rightView ? false : Object.keys(rightView).length > 0 ? this.getMultimediaSrc({ mediaObj: rightView, coverImage }) : false,

        };

        const { SmetioSlideShow } = (await import(/* webpackPrefetch: true */ "../../smetioSlideShow/SmetioSlideShow.js"));
        
        this.smetioSlideShow = new SmetioSlideShow({});
        this.smetioSlideShow.onSlideChanged = () => {
            const videos = document.querySelectorAll(".smetio-customer-website-treatment-details-display-slide-video");
            if (!videos) return false;
            videos.forEach((video) => { 
                video.pause();
            });
        };
        

        const videoClass = `class="smetio-customer-website-treatment-details-display-slide-video"`;
        let count = 0;

        for (const key in photoSrcs) {
            const imgSrc = photoSrcs[key];
            if (!imgSrc) continue;        
            this.smetioSlideShow.add_items({
                content: key.includes("video") === false ? `<img src="${imgSrc}" >` : `<video ${videoClass} controls> <source src="${imgSrc}" type="video/mp4"> </video>`,
                showIcon: true,
                indicator: {icon: "circle", text:"", isActive:"yes"}
            });  
            count++;
            
        };

        if (count < 2) this.smetioSlideShow.show_controller = "no";

        this.smetioSlideShow.indicatorPlacement = "bottom";
        this.smetioSlideShow.controllerPlacement = "bottom";
        const slides = this.smetioSlideShow.render();

        const pricingDetailText = this.setTxt({
            attributes: {},
            txt: "txt1865",
            type: "html"
        });

        const discountsAndPointsText = this.setTxt({
            attributes: {},
            txt: "txt1338",
            type: "html"
        });
        
        const timeEstimateText = this.setTxt({
            attributes: {},
            txt: "txt1866",
            type: "html"
        });        

        const cancellationPolicyText = this.setTxt({
            attributes: {},
            txt: "txt1339",
            type: "html"
        });  
        
        const bookNowText = this.setTxt({
            attributes: {},
            txt: "txt1867",
            type: "html"
        });        
        
        const commentText = this.setTxt({
            attributes: {},
            txt: "txt1201",
            type: "html"
        });    
        
        const faqText = this.setTxt({
            attributes: {},
            txt: "txt1364",
            type: "html"
        });     
        
        const paradepends = this.setTxt({ attributes: {}, txt: "txt1892", type: "html" }); 
        const priceMayVary = this.setTxt({ attributes: {}, txt: "txt1893", type: "html" });
        
        window.linkFunc = (event) => {
            return this.bookAppointmentFunc({ event, treatmentDetails:this.treatmentsArray[index] });
        };
        const onClick = !this.isEmpty(bookingLink) ? "" : `onclick="event.stopPropagation(); window.linkFunc(event);"`;
        const businessBookingLink = this.usefulLinksObj["plainObj"]["bookAppointment"]["href"];
        const bookAppointmentLink = !this.isEmpty(bookingLink) ? bookingLink : businessBookingLink;

        const content = `
            <div class="smetio-customer-website-treatment-details-display">
               
                <div class="smetio-customer-website-treatment-details-display-slide">${slides}</div>
                
                <div class="smetio-customer-website-treatment-details-display-title-description">
                    <h4> ${treatmentName}</h4>
                    <p>${description}</p>
                </div>

                <div class="smetio-customer-website-treatment-details-display-drop-down">
                    <h6 class="smetio-customer-website-treatment-details-display-drop-down-heading"> 
                        <i class="smetio-icon smetio-icon-credit-card1"></i>
                        ${pricingDetailText}
                    </h6>
                    <div class="smetio-customer-website-treatment-details-display-drop-down-details">
                        <div class="smetio-customer-website-treatment-details-display-drop-down-details-item">${paradepends}</div>
                        <div class="smetio-customer-website-treatment-details-display-drop-down-details-item">
                            <p class="smetio-dominant-text"> <i>${priceMayVary} </i> </p>
                        </div>                                                
                        ${this.getPriceDisplay({whatBodyPart, prices})}
                    </div>
                </div>

                <div class="smetio-customer-website-treatment-details-display-drop-down">
                    <h6 class="smetio-customer-website-treatment-details-display-drop-down-heading"> 
                        <i class="smetio-icon smetio-icon-gift2"></i>
                        ${discountsAndPointsText}
                    </h6>
                    <div class="smetio-customer-website-treatment-details-display-drop-down-details">
                        ${this.getDiscountsAndPointsDisplay({discountsAndPoints})}
                    </div>
                </div>                
                
                <div class="smetio-customer-website-treatment-details-display-drop-down">
                    <h6 class="smetio-customer-website-treatment-details-display-drop-down-heading"> 
                        <i class="smetio-icon smetio-icon-alarm"></i>
                        ${timeEstimateText}
                    </h6>
                    <div class="smetio-customer-website-treatment-details-display-drop-down-details">
                        ${this.getTimeEstimateDisplay({whatBodyPart, averagePerformanceMarginOfError, averageTimeOfPerformanceInMinutes})}
                    </div>
                </div>     
                
                <div class="smetio-customer-website-treatment-details-display-drop-down">
                    <h6 class="smetio-customer-website-treatment-details-display-drop-down-heading"> 
                        <i class="smetio-icon smetio-icon-stop1"></i>
                        ${cancellationPolicyText}
                    </h6>
                    <div class="smetio-customer-website-treatment-details-display-drop-down-details">
                        ${this.getCancellationPolicyDisplay({cancellationPolicy})}
                    </div>
                </div>  
                
                <div class="smetio-customer-website-treatment-details-display-drop-down">
                    <h6 class="smetio-customer-website-treatment-details-display-drop-down-heading"> 
                        <i class="smetio-icon smetio-icon-commenting-o"></i>
                        ${commentText}
                    </h6>
                    <div class="smetio-customer-website-treatment-details-display-drop-down-details">
                        <div class="smetio-customer-website-treatment-details-display-drop-down-details-item"> ${generalComments}</div>                       
                    </div>
                </div>                  

                <div class="smetio-customer-website-treatment-details-display-drop-down">
                    <h6 class="smetio-customer-website-treatment-details-display-drop-down-heading"> 
                        <i class="smetio-icon smetio-icon-question-circle-o"></i>
                        ${faqText}
                    </h6>
                    <div class="smetio-customer-website-treatment-details-display-drop-down-details">
                        <div class="smetio-customer-website-treatment-details-display-drop-down-details-item">
                            ${this.getFaqDisplay()}
                        </div>                       
                    </div>
                </div>  

                <button> 
                    <a ${onClick} href="${bookAppointmentLink}" target="_self">${bookNowText}</a>
                </button>
            </div>
        `;
        this.showOnSmartBox({ content, title: treatmentName });
        
    };

    async getTreatments() {

        const funcData = this.getFuncData();

        const serverMsg = await this.getDataFromServer({ ...funcData, type: "retrieve" });
        this.treatmentsArray = serverMsg.msg;
        this.totalNumberOfData = this.treatmentsArray.length;

        // console.log("this.totalNumberOfData is ", this.totalNumberOfData, " 49494949494949494949494949494949494949494949");

        this.displayTreatments();

    };

    async display() {
        await this.getHeadingText();

        this.getTreatments();

        $(`.${this.sectionHeadingClass}`).html(this.heading);

        if (this.nextSectionClass) this.nextSectionClass.display();

    };

    render() {

        this.events();

        //   const mapViewText = this.setTxt({
        //       attributes: this.mapViewBtnAttributes,
        //       txt: "txt1474",
        //       type: "title"
        //   });

        const seeDetailsText = this.setTxt({
            attributes: {},
            txt: "txt1475",
            type: "html"
        });
        let searchAndFilterBtn = this.getSearchAndFilterBtn();


        return `
        <section ${this.getAttributes(this.mainAttributes, false)}>

          <h2 ${this.getAttributes(this.sectionHeadingAttributes, false)} > I am treatment  </h2>

          <h6> ${seeDetailsText} </h6> 

          <div class="smetio-customer-website-treatments-search-filter">${searchAndFilterBtn}</div>

          <div ${this.getAttributes(this.treatmentsItemsAttributes, false)} ></div>
          
        </section>
    `;

    };


    events() {


        document.body.addEventListener("mousedown", (event) => {
                
            const element = event.target; 
            const parentElem = event.currentTarget;
            if (element.classList.contains("smetio-customer-website-treatment-details-display-drop-down-heading")) {
                const sibling = element?.nextElementSibling;
                
                if (sibling?.classList.contains("smetio-customer-website-treatment-details-display-drop-down-details")) {
                    
                    // document.querySelectorAll(".smetio-customer-website-treatment-details-display-drop-down-details").forEach(el => el.style.display = "none");

                    sibling.style.display = sibling.style.display === 'flex' ? 'none' : 'flex';
                };
            };

            // const bookBtnClass = "smetio-customer-website-description-book-with-me";
            // if (element.classList.contains(bookBtnClass) || parentElem.classList.contains(bookBtnClass)) { 
            //     console.log("the button is clicked &&&&&&&&&&&&&&&");
            //     event.stopImmediatePropagation();
            //     event.stopImmediatePropagation();
            // };

            
                
                
        });        


    };

};
